<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign.gt-xs="space-between center">
    <h1>Situação Inscrições do Concurso: </h1>
    <div>
      <app-export-button (export)="exportar()"></app-export-button>
    </div>
  </div>
  <h2> {{concursoTitulo}}</h2>

  <mat-form-field appearance="outline" display="inline-block">
    <mat-label>Filtrar</mat-label>
    <mat-select [(value)]="filtro" (valueChange)="selecionar()">
      <mat-option value="TODOS">TODOS</mat-option>
      <mat-option value="DEFERIDA">Deferido</mat-option>
      <mat-option value="INDEFERIDA">Indeferido</mat-option>
      <mat-option value="NAO_CONFIRMADA">Aguardando Análise</mat-option>
    </mat-select>
  </mat-form-field>

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nomeSocial || row.nome }}</td>
      </ng-container>
      <ng-container matColumnDef="cpf">
        <th mat-header-cell *matHeaderCellDef>CPF</th>
        <td mat-cell *matCellDef="let row">{{ row.cpf }}</td>
      </ng-container>
      <ng-container matColumnDef="protocolo">
        <th mat-header-cell *matHeaderCellDef>Protocolo</th>
        <td mat-cell *matCellDef="let row">{{ row.protocolo }}</td>
      </ng-container>
      <ng-container matColumnDef="pago">
        <th mat-header-cell *matHeaderCellDef>Pago</th>
        <td mat-cell *matCellDef="let row">{{ row.valor != 0 ? (row.pago ? 'Sim' : "Não") : "Gratuito" }}</td>
      </ng-container>
      <ng-container matColumnDef="situacao">
        <th mat-header-cell *matHeaderCellDef>Situação</th>
        <td mat-cell *matCellDef="let row">{{ row.situacao }}</td>
      </ng-container>
      <ng-container matColumnDef="motivo">
        <th mat-header-cell *matHeaderCellDef>Motivo</th>
        <td mat-cell *matCellDef="let row">{{ row.motivo }}</td>
      </ng-container>
      <ng-container matColumnDef="autor">
        <th mat-header-cell *matHeaderCellDef>Autor</th>
        <td mat-cell *matCellDef="let row">{{ row.autor }}</td>
      </ng-container>
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let row">{{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      </ng-container>
      <ng-container matColumnDef="concluida">
        <th mat-header-cell *matHeaderCellDef>Concluída</th>
        <td mat-cell *matCellDef="let row">{{ row.concluida ? 'Sim' : 'Não' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="10">
          <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>
</div>
